import React from 'react'
import { Navigate } from 'react-router-dom'
import { localStorageCluster } from '../../config'

const PrivateRoute = ({ children }) => localStorage.getItem(`${localStorageCluster}.token`) ? children : <Navigate to='/sign-in' />

export default PrivateRoute